import { __assign } from "tslib";
import * as React from 'react';
import { createPopper } from '@popperjs/core';
import offsetModifier from '@popperjs/core/lib/modifiers/offset';
import classNames from 'classnames';
import Popup from '../popup';
import '../popup/style/index';
var Popover = function (_a) {
    var _b = _a.prefixCls, prefixCls = _b === void 0 ? 'pptmui-popover' : _b, _c = _a.placement, placement = _c === void 0 ? 'bottom' : _c, _d = _a.theme, theme = _d === void 0 ? 'light' : _d, _e = _a.offset, offset = _e === void 0 ? [0, 12] : _e, _f = _a.overlayCloseable, overlayCloseable = _f === void 0 ? true : _f, _g = _a.duration, duration = _g === void 0 ? 100 : _g, _h = _a.transitionName, transitionName = _h === void 0 ? 'pptmui-popover-zoom' : _h, overlay = _a.overlay, onClose = _a.onClose, onOverlayClick = _a.onOverlayClick, className = _a.className, wrapperClassName = _a.wrapperClassName, contentClassName = _a.contentClassName, arrowClassName = _a.arrowClassName, overlayClassName = _a.overlayClassName, visible = _a.visible, content = _a.content, children = _a.children;
    var wrapperRef = React.useRef(React.createRef());
    var popoverRef = React.useRef(React.createRef());
    var popperObjectRef = React.useRef();
    var createPopperInstance = React.useCallback(function () {
        return createPopper(wrapperRef.current.current, popoverRef.current.current, {
            placement: placement,
            modifiers: [
                {
                    name: 'computeStyles',
                    options: {
                        adaptive: false,
                        gpuAcceleration: false,
                    },
                },
                __assign(__assign({}, offsetModifier), { options: {
                        offset: offset,
                    } }),
            ],
        });
    }, [placement, offset]);
    React.useEffect(function () {
        var popper = popperObjectRef.current;
        if (visible && !popper) {
            popper = createPopperInstance();
        }
        else if (visible && popper) {
            popper.setOptions({
                placement: placement,
            });
        }
    }, [visible, placement, createPopperInstance]);
    React.useEffect(function () {
        var popper = popperObjectRef.current;
        if (popper) {
            popper.setOptions({
                placement: placement,
            });
        }
    }, [placement]);
    var popoverCls = classNames(prefixCls, className, prefixCls + "--" + theme);
    var wrapperCls = classNames(prefixCls + "__wrapper", wrapperClassName);
    var arrowCls = classNames(prefixCls + "__arrow", arrowClassName);
    var contentCls = classNames(prefixCls + "__content", contentClassName);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { ref: wrapperRef.current, className: wrapperCls }, children),
        React.createElement(Popup, { ref: popoverRef.current, visible: visible, className: popoverCls, overlay: overlay, overlayClassName: overlayClassName, position: null, overlayCloseable: overlayCloseable, onOverlayClick: onOverlayClick, onClose: onClose, transitionName: transitionName, duration: duration },
            React.createElement("div", { className: arrowCls }),
            React.createElement("div", { className: contentCls }, content))));
};
export default Popover;
